import React from "react";

function Indeterminate() {
  return <progress className="indeterminate bg-purple-200 text-purple-600"></progress>;
}

export default Indeterminate;
